import { getTimeFromFirstContentfulPaint } from '@muse-web/analytics'
import { type ScreenId } from '@core/router'

import { readCachedCfContext } from './cf-context/cfContextCache'
import { resolveScreen } from './resolveScreen'
import { sendEvent } from './sendEvent'
import { setCurrentScreen } from './currentScreen'

const PAGE_VIEW_15S_DELAY = 15000

let pageView15sTimer: ReturnType<typeof setTimeout> | undefined

/**
 * Register a screen view: set the active screen, fire `page_view`, and schedule
 * `Page View 15s`. For the initial (backend-rendered) page the 15s clock is aligned
 * to FCP via `getTimeFromFirstContentfulPaint()`; on soft navigation it counts a full
 * 15s from the screen change.
 */
export const trackScreenView = (screenId: ScreenId, isInitial = false) => {
    setCurrentScreen(resolveScreen(screenId))

    const cf = readCachedCfContext()

    sendEvent({ name: 'page_view', payload: cf ? { cf } : {} })

    if (pageView15sTimer) {
        clearTimeout(pageView15sTimer)
    }

    const elapsedSinceFcp = isInitial ? getTimeFromFirstContentfulPaint() : 0
    const delay = Math.max(0, PAGE_VIEW_15S_DELAY - elapsedSinceFcp)

    pageView15sTimer = setTimeout(() => {
        sendEvent({ name: 'Page View 15s', payload: {} })
    }, delay)
}
